module.exports = __webpack_public_path__ + "img/pos-logo.4ffad42c.png";